/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */

import { AppContext } from '../app-context';
import ConfigWebApi from '../webapi/ConfigWebApi';
import ActionTypesCommon from '../constants/ActionTypesCommon';

export default {

    loadConfig(/*long*/scopeGroupId, /*long*/plid, /*String*/portletId, options) {
        const params = { scopeGroupId, plid, portletId };
        options.meta = {
            ...options.meta,
            ...params
        };
        return AppContext.getDispatcher().dispatchAsyncOperation(
            ActionTypesCommon.CONFIG_LOAD_ASYNC, ConfigWebApi.getPortletProperties, params, options);
    },

    updateConfig(/*long*/scopeGroupId, /*long*/plid, /*String*/portletId, config, options) {
        const params = { scopeGroupId, plid, portletId, properties: config };
        options.meta = {
            ...options.meta,
            ...params
        };
        return AppContext.getDispatcher().dispatchAsyncOperation(
            ActionTypesCommon.CONFIG_UPDATE_ASYNC, ConfigWebApi.savePortletProperties, params, options);
    },

    setConfig(/*long*/scopeGroupId, /*long*/plid, /*String*/portletId, config, callBack) {
        const params = { scopeGroupId, plid, portletId, config };
        let result = AppContext.getDispatcher().dispatch({
            type: ActionTypesCommon.CONFIG_SET,
            meta: {
                ...params
            },
            payload: { ...config }
        });
        callBack && callBack(config);
        return result;
    },

    updateLocalConfig(key, config, options = {}) {
        const params = { key, properties: config };

        options.meta = {
            ...options.meta,
            ...params
        };
        return AppContext.getDispatcher().dispatch({
            'type': ActionTypesCommon.CONFIG_LOCAL_UPDATE,
            'payload': params,
            'meta': {
                ...options,
                ...params
            }
        });
    }

};



// WEBPACK FOOTER //
// ./js/actions/ConfigActions.js